<ng-container *ngIf="processedCategories && processedCategories.length > 0; else noSkills">
    <div
      *ngFor="let category of processedCategories; let isFirst = first"
      [ngClass]="{'first-skill-set': isFirst}"
    >
      <p
        class="skill-category"
        data-qa-id="an_rjd_skillCategory_readonly"
      >
        {{ category.category }}
      </p>
      <div
        *ngFor="let skill of category.skills"
      >
        <ng-container *ngIf="skill.changeType === changeType.Unchanged && skill.originalValue && !skill.originalValue.isNA">
            <span data-qa-id="an_rjd_skillName_readonly">{{ skill.originalValue.name }}
            <span *ngIf="skill.originalValue.isPreferred">*</span></span>
        </ng-container>
        <ng-container *ngIf="skill.changeType === changeType.Added && !skill.newValue?.isNA">
            <span class="job-qualifications-compare-change-added">{{skill.newValue.name}}{{skill.newValue.isPreferred ? '*' : ''}}</span>
        </ng-container>
        <ng-container *ngIf="skill.changeType === changeType.Changed && skill.originalValue !== null">
            <span class="job-qualifications-compare-change-removed">{{skill.originalValue?.name}}{{skill.originalValue?.isPreferred ? '*' : ''}}</span>&nbsp;<span class="job-qualifications-compare-change-added">{{skill.newValue?.name}}{{skill.newValue?.isPreferred ? '*' : ''}}</span>
        </ng-container>
        <ng-container *ngIf="skill.changeType === changeType.Removed && skill.originalValue !== null">
            <span class="job-qualifications-compare-change-removed">{{skill.originalValue?.name}}{{skill.originalValue?.isPreferred ? '*' : ''}}</span>
        </ng-container>
      </div>
    </div>
</ng-container>
<ng-template #noSkills>-</ng-template>